import { render, staticRenderFns } from "./codeadd.vue?vue&type=template&id=2faf5488&"
import script from "./codeadd.vue?vue&type=script&lang=js&"
export * from "./codeadd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports